import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"

import { addComment } from "../services/cloudService"
import { refresh } from "../reducers/cloudReducer"

import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid"
import Avatar from "@mui/material/Avatar"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemAvatar from "@mui/material/ListItemAvatar"
import ListItemText from "@mui/material/ListItemText"

import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"

import DayJS from "react-dayjs"
import { useSnackbar } from "notistack"

const VoucherComment = ({ comment }) => {
  return (
    <div>
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            {comment.nimi
              .split(" ")
              .map((n) => n[0])
              .join("")}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <div style={{ whiteSpace: "pre-line" }}>{comment.teksti}</div>
          }
          secondary={
            <span>
              {comment.nimi}{" "}
              <DayJS format="DD.MM.YYYY HH.mm" date={comment.aika} />
            </span>
          }
        />
      </ListItem>
    </div>
  )
}

const VoucherComments = (props) => {
  const { t } = useTranslation("voucherComments")
  const [newComment, setNewComment] = useState("")
  const { enqueueSnackbar } = useSnackbar()

  if (
    (!props.comments || props.comments.length === 0) &&
    !props.rights.includes("Tk")
  ) {
    return null
  }

  const saveComment = async () => {
    try {
      console.log("Uusi kommentti")
      await addComment(props.docId, newComment)
      console.log("lisätty")
      setNewComment("")
      await props.refresh()
    } catch (e) {
      console.log(e.stack)
      enqueueSnackbar(t("failed"), { variant: "error" })
    }
  }

  return (    
      <Container text>
        <List>
          {props.comments &&
            props.comments.map((item) => (
              <VoucherComment comment={item} key={item.id} />
            ))}
        </List>
        {props.rights.includes("Tk") && (
          <div>
            <Grid container alignItems="center" spacing={1}>
              <Grid item sm={12} xs={12}>
                <TextField
                  multiline
                  rows={3}
                  variant="outlined"
                  fullWidth
                  placeholder={t("placeholder")}
                  value={newComment}
                  onChange={(e) => setNewComment(e.target.value)}
                />
              </Grid>
              <Grid item sm={12} xs={12}>
                <Button
                  fullWidth
                  disabled={newComment.length === 0}
                  variant="contained"
                  color="primary"
                  onClick={() => saveComment()}
                >
                  {t("button")}
                </Button>
              </Grid>
            </Grid>
          </div>
        )}
      </Container>    
  )
}

const mapStateToButtonProps = (state) => {
  return {
    rights: state.cloud && state.cloud.current && state.cloud.current.rights,
  }
}

export default connect(mapStateToButtonProps, { refresh })(VoucherComments)
